<template>
    <MContainer class="w-full gap-4">
        <MContainerGrow>
            <MUButton :toggled="btnDicom.pressed" v-bind:label="$t('web-rg.uploadDicom')" v-bind:class="['btn-wizard-md w-full web-rg-wiz-btn']" v-on:click="setDicom" />
        </MContainerGrow>
        <MContainerGrow class="col flex grow">
            <MUButton :toggled="btnStl.pressed" v-bind:label="$t('web-rg.uploadObject')" v-bind:class="['btn-wizard-md w-full web-rg-wiz-btn']" v-on:click="setStl" />
        </MContainerGrow>
        <MContainerGrow class="col flex grow">
            <MUButton :toggled="btnImage.pressed" v-bind:label="$t('web-rg.uploadImages')" v-bind:class="['btn-wizard-md w-full web-rg-wiz-btn']" v-on:click="setImage" />
        </MContainerGrow>
        <MContainerGrow class="col flex grow">
            <MUButton :toggled="btnDocument.pressed" v-bind:label="$t('web-rg.uploadDocuments')" v-bind:class="['btn-wizard-md w-full web-rg-wiz-btn']" v-on:click="setDocument" />
        </MContainerGrow>
    </MContainer>
</template>
<script lang="ts" setup>
import { ref, watch, reactive } from "vue";
import { ButtonModel, MUButton, MContainer, MContainerGrow } from "@xlabmedical/medic-web-framework";

const emits = defineEmits<{ (e: "setActive", value: UIState): void }>();

enum UIState {
    UPLOADING_OBJECT,
    UPLOADING_DICOM,
    UPLOADING_IMAGE,
    UPLOADING_DOCUMENT,
}

const state = ref<UIState>(UIState.UPLOADING_DICOM);

const updateButtons = () => {
    btnStl.pressed = state.value === UIState.UPLOADING_OBJECT;
    btnDicom.pressed = state.value === UIState.UPLOADING_DICOM;
    btnImage.pressed = state.value === UIState.UPLOADING_IMAGE;
    btnDocument.pressed = state.value === UIState.UPLOADING_DOCUMENT;
};

watch(state, () => {
    updateButtons();
});

let btnStl: ButtonModel = reactive({
    disabled: false,
    pressable: true,
    pressed: state.value === UIState.UPLOADING_OBJECT,
});

let btnDicom: ButtonModel = reactive({
    disabled: false,
    pressable: true,
    pressed: state.value === UIState.UPLOADING_DICOM,
});

let btnImage: ButtonModel = reactive({
    disabled: false,
    pressable: true,
    pressed: state.value === UIState.UPLOADING_IMAGE,
});

let btnDocument: ButtonModel = reactive({
    disabled: false,
    pressable: true,
    pressed: state.value === UIState.UPLOADING_DOCUMENT,
});

const setDicom = () => {
    state.value = UIState.UPLOADING_DICOM;
    emits("setActive", state.value);
};

const setStl = () => {
    state.value = UIState.UPLOADING_OBJECT;
    emits("setActive", state.value);
};

const setImage = () => {
    state.value = UIState.UPLOADING_IMAGE;
    emits("setActive", state.value);
};

const setDocument = () => {
    state.value = UIState.UPLOADING_DOCUMENT;
    emits("setActive", state.value);
};
</script>
